<template>
  <scout-form
    :is-modified="!!value || !!excludeWord"
    label="フリーワード検索"
  >
    <div class="boss-layout boss-layout-vertical">
      <div>
        <div class="boss-separated-small">
          <div class="boss-layout boss-layout-start boss-layout-gap-large">
            <div>
              <label>絞り込みワード</label>
            </div>
            <label
              v-for="(option, i) in operatorOption"
              :key="i"
              :data-test="`option-${i}`"
              class="pega-input"
            >
              <input
                :checked="operator === option.key"
                :value="option.key"
                type="radio"
                name="free-word"
                class="boss-input-checkbox"
                @change="$emit('update:operator', $event.target.value)"
              >{{ option.label }}
            </label>
          </div>
        </div>
        <div class="boss-layout boss-layout-start">
          <div class="boss-layout-item-grow">
            <input
              :value="value"
              type="text"
              placeholder="複数入力時は半角・全角スペースで区切ってください"
              class="boss-input boss-input-fill"
              :class="{ 'is-invalid-input': !!freeWordErrorMessage }"
              data-test="free-word"
              @change="$emit('input', $event.target.value)"
            >
            <validation-label
              v-if="!!freeWordErrorMessage"
              :label="freeWordErrorMessage"
              data-test="free-word-validation"
            />
          </div>
        </div>
      </div>
      <div>
        <span class="margin-right-1">除外キーワード</span>
        <span class="boss-annotation-text">
          ※いずれかのキーワードを含む対象を除外します
        </span>
        <div class="boss-layout boss-layout-start">
          <div class="boss-layout-item-grow">
            <input
              :value="excludeWord"
              type="text"
              placeholder="複数入力時は半角・全角スペースで区切ってください"
              class="boss-input boss-input-fill"
              :class="{ 'is-invalid-input': !!excludeWordErrorMessage }"
              data-test="exclude-word"
              @change="$emit('update:excludeWord', $event.target.value)"
            >
            <validation-label
              v-if="!!excludeWordErrorMessage"
              :label="excludeWordErrorMessage"
              data-test="exclude-word-validation"
            />
          </div>
        </div>
      </div>
    </div>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import ValidationLabel from '@/components/atoms/ValidationLabel'

export default {
  components: {
    ScoutForm,
    ValidationLabel
  },
  props: {
    value: {
      required: true,
      type: String
    },
    freeWordErrorMessage: {
      default: '',
      type: String
    },
    excludeWord: {
      default: '',
      type: String
    },
    excludeWordErrorMessage: {
      default: '',
      type: String
    },
    operator: {
      default: '',
      type: String
    }
  },
  data () {
    return {
      operatorOption: [{ key: 'and', label: 'すべてのキーワードを含む' }, { key: 'or', label: 'いずれかのキーワードを含む' }]
    }
  }
}
</script>
